"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _icons = require("../../../assets/icons");

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

var _MenuButton = require("./MenuButton.styles");

var MenuButton = function MenuButton(_ref) {
  var doToggleLeftSidebar = _ref.doToggleLeftSidebar,
      isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
      onClick = _ref.onClick;
  var handleHamburgerClick = (0, _react.useCallback)(function (e) {
    doToggleLeftSidebar();

    if (onClick) {
      onClick(e);
    }
  }, [doToggleLeftSidebar, onClick]);
  return (0, _jsxRuntime.jsx)(_Tooltip["default"], {
    position: "right",
    title: "".concat(isLeftSidebarCollapsed ? 'Show' : 'Hide', " navigation"),
    children: (0, _jsxRuntime.jsx)(_Button["default"], {
      css: [_MenuButton.styles.base, isLeftSidebarCollapsed && _MenuButton.styles.collapsed, process.env.NODE_ENV === "production" ? "" : ";label:MenuButton;"],
      "data-test-id": "Hamburger",
      onClick: handleHamburgerClick,
      type: "icon",
      children: (0, _jsxRuntime.jsx)(_icons.Menu, {})
    })
  });
};

MenuButton.propTypes = {
  doToggleLeftSidebar: _propTypes.func,
  isLeftSidebarCollapsed: _propTypes.bool,
  onClick: _propTypes.func
};
MenuButton.defaultProps = {
  doToggleLeftSidebar: _propTypes.func,
  isLeftSidebarCollapsed: false,
  onClick: function onClick() {}
};
var _default = MenuButton;
exports["default"] = _default;
//# sourceMappingURL=MenuButton.js.map